/** Preferências do fantasma do gabarito (por processo) — localStorage. */

const STORAGE_KEY = 'ingressa_exam_objective_overlay_prefs';

export const OVERLAY_DEFAULTS = {
  opacity: 0.55,
  offsetX: 0,
  offsetY: 0,
  scale: 100,
  scaleX: 100,
};

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* quota / modo privado */
  }
}

export function loadExamObjectiveOverlayPrefs(processId) {
  const all = readAll();
  const key = processId != null ? String(processId) : 'global';
  const saved = all[key] || all.global || {};
  return {
    opacity:
      typeof saved.opacity === 'number' ? saved.opacity : OVERLAY_DEFAULTS.opacity,
    offsetX: typeof saved.offsetX === 'number' ? saved.offsetX : OVERLAY_DEFAULTS.offsetX,
    offsetY: typeof saved.offsetY === 'number' ? saved.offsetY : OVERLAY_DEFAULTS.offsetY,
    scale: typeof saved.scale === 'number' ? saved.scale : OVERLAY_DEFAULTS.scale,
    scaleX: typeof saved.scaleX === 'number' ? saved.scaleX : OVERLAY_DEFAULTS.scaleX,
  };
}

export function saveExamObjectiveOverlayPrefs(processId, prefs) {
  const key = processId != null ? String(processId) : 'global';
  const all = readAll();
  all[key] = {
    opacity: prefs.opacity,
    offsetX: prefs.offsetX,
    offsetY: prefs.offsetY,
    scale: prefs.scale,
    scaleX: prefs.scaleX ?? OVERLAY_DEFAULTS.scaleX,
  };
  writeAll(all);
}
